/**
 * @generated SignedSource<<8995b086955a1ae006b5cc94a837f420>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ClientRequest, ClientQuery } from 'relay-runtime';
export type useCurrentTab452BadPatternQuery$variables = Record<PropertyKey, never>;
export type useCurrentTab452BadPatternQuery$data = {
  readonly jira: {
    readonly centralizedFieldsAdminPage: {
      readonly currentSidebar: {
        readonly currentFieldNodeId: string | null | undefined;
      } | null | undefined;
    };
  } | null | undefined;
};
export type useCurrentTab452BadPatternQuery = {
  response: useCurrentTab452BadPatternQuery$data;
  variables: useCurrentTab452BadPatternQuery$variables;
};

const node: ClientRequest = (function(){
var v0 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "concreteType": "CentralizedFieldsAdminPage",
            "kind": "LinkedField",
            "name": "centralizedFieldsAdminPage",
            "plural": false,
            "selections": [
              {
                "concreteType": "AdminPagesFieldsSidebar",
                "kind": "LinkedField",
                "name": "currentSidebar",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "currentFieldNodeId"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useCurrentTab452BadPatternQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useCurrentTab452BadPatternQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a18e7e5734dbcf7e85844c88aaee9049",
    "id": null,
    "metadata": {},
    "name": "useCurrentTab452BadPatternQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bc998bda7384f3e82959d8b0518fe845";

export default node;
